import React from 'react';
import { createOpenAIModalCommand } from '../pm-plugins/decoration/actions';
import { Logo } from '../ui/components/Logo/Logo';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export function mapConfigItemsToQuickInsertItems({
  configItems,
  formatMessage,
  aiGlobalOptIn,
  editorView
}) {
  const aiPriorities = 9000;
  const dispatch = editorView.dispatch;
  return configItems
  // hide quickInsert items that shouldn't be visible (for e.g. because of
  // an empty document, or other config-defined logic)
  .filter(configItem => {
    if (getBooleanFF('platform.editor.ai-dynamic-show-hide-quick-insert-items_4ie8s')) {
      return configItem.isVisible({
        editorView
      });
    }
    if (getBooleanFF('platform.editor.ai-enable-multi-lang-translation-prompts')) {
      var _configItem$title, _configItem$title$sta;
      if ((_configItem$title = configItem.title({
        formatMessage
      })) !== null && _configItem$title !== void 0 && (_configItem$title$sta = _configItem$title.startsWith) !== null && _configItem$title$sta !== void 0 && _configItem$title$sta.call(_configItem$title, 'Translate to')) {
        if (getBooleanFF('platform.editor.ai-enable-multi-lang-translations-in-quick-insert')) {
          return true;
        }
        return false;
      }
    }
    return configItem;
  }).map(configItem => {
    var _configItem$quickInse, _configItem$descripti;
    return {
      priority: (_configItem$quickInse = configItem.quickInsertPriority) !== null && _configItem$quickInse !== void 0 ? _configItem$quickInse : aiPriorities,
      categories: getBooleanFF('platform.editor.ai-elementbrowser-ai-category_cw2x3') ? ['AI'] : [],
      title: configItem.title({
        formatMessage
      }),
      description: ((_configItem$descripti = configItem.description) === null || _configItem$descripti === void 0 ? void 0 : _configItem$descripti.call(configItem, {
        formatMessage
      })) || configItem.title({
        formatMessage
      }),
      keywords: ['ai', 'generate', configItem.title({
        formatMessage
      })],
      icon: () => {
        return configItem.icon ? configItem.icon({
          formatMessage,
          shownAt: 'quickInsert'
        }) : /*#__PURE__*/React.createElement(Logo, null);
      },
      action: (insert, editorState) => {
        // TODO POSTEAP
        // Post EAP our intention is to kick off a state machine on entry --
        // and have a transistion on the state machine which starts the decoration
        // on the document, and links a content comopnent to the decoration.
        //
        // For now we set the openAIModalCommand to run on the next tick for now -- as it then
        // performs additional transactions to update the document (in a way that does not
        // reflect later direction)

        requestAnimationFrame(() => {
          const openAIModalCommand = createOpenAIModalCommand({
            state: editorView.state,
            configItem,
            lastTriggeredFrom: 'quickInsert',
            aiGlobalOptIn
          });
          openAIModalCommand(editorView.state, dispatch);
        });

        // Insert empty string to remove the typeahead raw text
        // close the quick insert immediately
        const transaction = insert('');
        return transaction;
      }
    };
  });
}